import { FC, ReactElement, useRef, useState } from 'react'
import { useOnClickOutside } from 'src/hooks/useOnClickOutside'

interface SelectBlueProps {
  name: string;
  formik: any;
  options: Option[];
}

interface Option {
  label: string;
  value: number;
}

export const SelectBlue: FC<SelectBlueProps> = ({
  name,
  formik,
  options = [],
}): ReactElement => {
  const refSelect = useRef<HTMLDivElement>(null)
  const [isActive, setIsActive] = useState(false)
  const [value, setValue] = useState<Option>()

  useOnClickOutside(refSelect, () => setIsActive(false))

  const handleClick = () => {
    setIsActive(!isActive)
  }

  const handleChange = (item: Option) => () => {
    setValue(item)
    formik.setFieldValue(name, item.value)
  }

  return (
    <div
      ref={refSelect}
      className={isActive ? 'select active' : 'select'}
      onClick={handleClick}
    >
      <div className="select-top">
        <span className="select-text">{value ? value.label : 'Select'}</span>
      </div>
      <div className="select-info">
        <ul>
          {options.map((x) => (
            <li key={x.value}>
              <a href="#" onClick={handleChange(x)}>
                {x.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
      <input type="text" className="select-value" name={name} value={value?.value} />
    </div>
  )
}
